import React from "react";
import {connect} from "react-redux";
import Impressum from "../components/Impressum";

const mapStateToProps = state => ({

});

const mapDispatchToProps = {

};

class ImpressumContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            refreshPageController: false
        }
    }

    render() {
        return (
            <div>
                <Impressum />
            </div>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ImpressumContainer);


// WEBPACK FOOTER //
// ./src/container/ImpressumContainer.js